import { theme } from '~/theme';
export const useSxStyles = () => {
  return {
    root: {
      position: 'relative',
      height: '100%',
      width: '100%',
    },
    rootBefore: {
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(transparent calc(100% - 100px), white)',
        pointerEvents: 'none',
      },
    },
    readMoreButton: {
      padding: theme.spacing(0, 0.75),
      fontSize: '0.5625rem',
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: '100%',
      height: '100%',
      justifyContent: 'end',
      alignItems: 'end',
      '&:focus': {
        outline: 'none',
      },
    },
    listItemRoot: {
      padding: theme.spacing(0.5, 0, 0.5, 0),
      height: '20%',
    },
    listItemText: {
      margin: 0,
    },
    listItemPrimary: {
      fontSize: '0.875rem',
      '&>.MuiBox-root': {
        whiteSpace: 'normal',
      },
    },
    listItemSecondary: {
      fontSize: '0.75rem',
    },
    message: {
      wordBreak: 'break-word',
      marginTop: theme.spacing(0.5),
      '& a': {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        width: '100%',
        overflowWrap: 'break-word',
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
    hidden: {
      display: 'none',
    },
  };
};
